<div style="height: 30px; width: 240px">
  <canvas #chartRef></canvas>
</div>
